/**
 * Add/Edit Billing entity form — Settings → Billing entities.
 */
import { z } from 'zod';
import { US_STATE_CODES } from '@/pages/onboarding/constants';
import { STRIPE_CONNECTED_ACCOUNT_ID_PATTERN } from '@unify/fhir-model/resources/organization';

export const billingEntitySchema = z.object({
  name: z.string().trim().min(1, 'Name is required'),
  state: z
    .string()
    .trim()
    .min(1, 'State is required')
    .transform((value) => value.toUpperCase())
    .refine((value) => (US_STATE_CODES as readonly string[]).includes(value), {
      message: 'Select a valid US state',
    }),
  npi: z.string().trim().min(1, 'NPI is required'),
  ein: z.string().trim().min(1, 'EIN is required'),
  phone: z.string().trim().optional(),
  street: z.string().trim().min(1, 'Street address is required'),
  city: z.string().trim().min(1, 'City is required'),
  postalCode: z.string().trim().min(1, 'ZIP is required'),
  stripeConnectedAccountId: z
    .string()
    .trim()
    .min(1, 'Stripe Connected-Account ID is required')
    .refine((value) => STRIPE_CONNECTED_ACCOUNT_ID_PATTERN.test(value), {
      message: 'Must be a Stripe connected-account id (acct_…)',
    }),
});

export type BillingEntityFormInput = z.infer<typeof billingEntitySchema>;

export const defaultBillingEntityFormValues: BillingEntityFormInput = {
  name: '',
  state: '',
  npi: '',
  ein: '',
  phone: '',
  street: '',
  city: '',
  postalCode: '',
  stripeConnectedAccountId: '',
};
